export const isMobileDevice = function (userAgent = null) {
    const savedIsMobile = localStorage.isMobile;
    const ua = userAgent ? userAgent : window.navigator.userAgent;
    //iPhone  - "Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1"
    //iPad    - "Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1"
    //iPadPro - "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Safari/605.1.15"
    //Samsung - "Mozilla/5.0 (Linux; Android 8.0.0; SM-G955U Build/R16NW) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.141 Mobile Safari/537.36"
    const isMobileTest = /Mobi|Android/i.test(ua);
    const isiPadRequestDesktopWebsite =
        navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(ua);
    const isMobile = isMobileTest && !isiPadRequestDesktopWebsite;

    if (savedIsMobile && isMobile) {
        return Boolean(savedIsMobile);
    } else {
        if (isMobile) {
            // if initial view is mobile, save this in case user changes ua later via "Request Desktop Website"
            localStorage.setItem("isMobile", isMobile);
        }
        return Boolean(isMobile);
    }
};
